// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".playlist-widget-panel[data-v-e427a62a] {\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  margin-right: 0px;\n  padding-right: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.playlist-widget-panel .form-group[data-v-e427a62a] {\n  margin-bottom: 0;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
